import { SteppedPrimaryActions, useSteppedDialogForm } from '@mews-commander/form';
import { lt } from '@mews/framework';
import { useEnterprisesProductContext } from '../../context/EnterprisesProductContext';
import { ConfigureProductFormStep } from '../forms/schemas/configureProductFormSchema';
import { ConfigureProductFormContent } from './ConfigureProductForm';
import { configureProductSteps } from './utils';

export const useConfigureProductDialogForm = () => {
    const {
        state: { selectedEnterpriseIds },
    } = useEnterprisesProductContext();

    return useSteppedDialogForm<ConfigureProductFormStep>({
        id: 'configureProductForm',
        title: lt('ConfigureProductHeading', { count: selectedEnterpriseIds.length }),
        steps: configureProductSteps,
        size: selectedEnterpriseIds.length > 1 ? 'large' : 'medium',
        stepLabels: {
            details: lt('ConfigureProductStepperDetails'),
            taxes: lt('ConfigureProductStepperTaxes'),
            pricing: lt('ConfigureProductStepperPricing'),
            accounting: lt('ConfigureProductStepperAccounting'),
            services: lt('ConfigureProductStepperServices'),
        },
        optionalSteps: {
            details: true,
            taxes: true,
            accounting: true,
            services: true,
        },
        renderForm: (props) => <ConfigureProductFormContent enterpriseIds={selectedEnterpriseIds} {...props} />,
        renderPrimaryAction: (props) => <SteppedPrimaryActions {...props} />,
    });
};
